import { Icon } from '../Icon'

export default function Error({ children }: { children: React.ReactElement | string }): React.ReactElement {
  return (
    <div className="mt-2 mx-auto py-2 px-4 flex items-center border bg-white border-gray-placeholder text-black rounded">
      <Icon className="text-red mr-2" name="error_outline" />
      {children}
    </div>
  )
}
